import { getAdTokenRedirect } from '@/utils/active_directory_helper'

export const baseAuthHeaders = async (): Promise<
  Record<string, string | never>
> => {
  const token = await getAdTokenRedirect()
  if (!token) return {}
  return { Authorization: `Bearer ${token}` }
}
